// | Specular interface to Skubacz.Progress.
import * as $runtime from "../runtime.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Utils$dProgress from "../Utils.Progress/index.js";
const showProgress = dictMonadFRP => Specular$dFRP$dBase.subscribeDyn_(dictMonadFRP)(v => {
  if (v.tag === "Just") { return Utils$dProgress.showProgress(v._1); }
  if (v.tag === "Nothing") { return Utils$dProgress.hideProgress; }
  $runtime.fail();
});
export {showProgress};
